
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { myMessage, checkListQc, checkList, getCheckType } from '@/api/yuangongquan'
import config from '@/config/index'
import Scroll from '@/components/scroller'
export default {
components: { Tab, TabItem, Scroll },
data () {
return {
baseUrl: config.baseUrl,
active: 0,
pageSize: 15,
pageCurrent: 1,
listObj: [],
notFirstLoad: false,
loadMoreDom: null,
chekcType: []
}
},
computed: {
userid () {
return this.$store.state.user.userid
},
acctname () {
return this.$store.state.user.personObj.acctname
},
isAdmin () {

return this.$store.state.user.personObj.isAdmin
}
},
beforeRouteEnter (to, from, next) {
if (from.name !== 'yuangongquanDetail') {
to.meta.isUseCache = false
}
next()
},
activated () {
if (!this.$route.meta.isUseCache) {
this.active = 0
this.pageCurrent = 1
this.getCheckList()
this.myMessage()
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
}
},
mounted () {
},
methods: {
onItemClick (val) {
if (this.active === val) return
if (val === 0) {
this.pageCurrent = 1
this.myMessage()
} else if (val === 1) {
this.pageCurrent = 1
this.myReport()
}
this.active = val
},

myMessage (type, done) {
myMessage({
pageSize: this.pageSize,
pageCurrent: this.pageCurrent,
userid: this.userid
})
.then(res => {
if (res.success) {
if (type === 'refresh') {
this.listObj = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.obj
if (obj.length === 0 && this.pageCurrent === 1) {
this.listObj = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
this.listObj =
this.pageCurrent === 1 ? obj : [...this.listObj, ...obj]
if (this.pageSize > res.obj.length) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
}
})
.catch(() => {
this.notFirstLoad = true
done && done()
})
},

myReport (type, done) {
if (this.isAdmin === 1) {

checkListQc({
pageSize: this.pageSize,
pageCurrent: this.pageCurrent
})
.then(res => {
if (res.success) {
if (type === 'refresh') {
this.listObj = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.obj
if (obj.length === 0 && this.pageCurrent === 1) {
this.listObj = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
obj.forEach(item => {
item.checktypeName = []
let arr = item.checktype.split(';')
arr.map(o => {
this.chekcType.filter(m => {
m.key === o && item.checktypeName.push(m.value)
})
})
})
this.listObj =
this.pageCurrent === 1 ? obj : [...this.listObj, ...obj]
if (this.pageSize > res.obj.length) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
}
})
.catch(() => {
this.notFirstLoad = true
done && done()
})
} else {

checkList({
pageSize: this.pageSize,
pageCurrent: this.pageCurrent,
userid: this.userid
})
.then(res => {
if (res.success) {
if (type === 'refresh') {
this.listObj = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.obj
if (obj.length === 0 && this.pageCurrent === 1) {
this.listObj = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
obj.forEach(item => {
item.checktypeName = []
let arr = item.checktype.split(';')
arr.map(o => {
this.chekcType.filter(m => {
m.key === o && item.checktypeName.push(m.value)
})
})
})
this.listObj =
this.pageCurrent === 1 ? obj : [...this.listObj, ...obj]
if (this.pageSize > res.obj.length) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
}
})
.catch(() => {
this.notFirstLoad = true
done && done()
})
}
},

getCheckList () {
getCheckType({
addTreeNode: 1
}).then(res => {
this.chekcType = res.obj
})
},

refresh (done) {
this.pageCurrent = 1
this.loadMoreDom.innerText = '加载中...'
if (this.active === 0) {
this.myMessage('refresh', done)
} else if (this.active === 1) {
this.myReport('refresh', done)
}
},

loadMore (done) {
this.pageCurrent++
this.loadMoreDom.innerText = '加载中...'
if (this.active === 0) {
this.myMessage('more', done)
} else if (this.active === 1) {
this.myReport('more', done)
}
},
detail (obj) {
if (obj.isCheck === '1') {
this.$vux.toast.text('已删除')
} else {
this.$router.push({ name: 'yuangongquanDetail', params: { id: obj.id } })
}
}
}
}
